import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '../../../app/utils/baseQueryWithReauth';

export const paymentsApi = createApi({
    reducerPath: 'paymentsApi',
    baseQuery: baseQueryWithReauth(process.env.REACT_APP_PAYMENTS_SERVICE_URL),
    endpoints: (builder) => ({
        getPaymentEmail: builder.query({
            query: () => ({
                url: '/v1/email',
                method: 'GET',
            }),
        }),
        getBalance: builder.query({
            query: () => ({
                url: '/v1/balance',
                method: 'GET',
            }),
        }),
        calculateSubscription: builder.mutation({
            query: ({ bot_id, service, tariff_id = 1, channel_ids = [], days, use_balance = false, promo_code }) => ({
                url: '/v1/calculate',
                method: 'POST',
                body: { bot_id, service, tariff_id, channel_ids, days, use_balance, promo_code },
            }),
        }),
        createSubscriptionPayment: builder.mutation({
            query: ({ bot_id, service, tariff_id = 1, channel_ids = [], days, payment_system, use_balance = false, email, promo_code, recurrent = false }) => ({
                url: '/v1/subscribe',
                method: 'POST',
                body: { bot_id, service, tariff_id, channel_ids, days, payment_system, use_balance, email, promo_code, recurrent },
            }),
        }),
        createBalanceTopup: builder.mutation({
            query: ({ amount, payment_system, email }) => ({
                url: '/v1/topup',
                method: 'POST',
                body: { amount, payment_system, email },
            }),
        }),
        getBusinessSubscription: builder.query({
            query: () => ({
                url: '/v1/business/subscription',
                method: 'GET',
            }),
        }),
        getChannelsSubscriptions: builder.query({
            query: (botId) => ({
                url: '/v1/channels/subscriptions',
                method: 'GET',
                params: botId ? { bot_id: botId } : {},
            }),
        }),
        getAffiliateStats: builder.query({
            query: () => ({
                url: '/v1/affiliate/stats',
                method: 'GET',
            }),
        }),
        getPaymentStatus: builder.query({
            query: (paymentId) => ({
                url: `/v1/status/${paymentId}`,
                method: 'GET',
            }),
        }),
    }),
});

export const {
    useGetPaymentEmailQuery,
    useGetBalanceQuery,
    useCalculateSubscriptionMutation,
    useCreateSubscriptionPaymentMutation,
    useCreateBalanceTopupMutation,
    useGetBusinessSubscriptionQuery,
    useGetChannelsSubscriptionsQuery,
    useGetAffiliateStatsQuery,
    useGetPaymentStatusQuery,
} = paymentsApi;
